import React from 'react';
import RadioButton from '../../Shared/RadioButton/RadioButton';
import DeliveryMethodEstimation from '../DeliveryMethodEstimation/DeliveryMethodEstimation';
import './DeliveryMethod.scss';

const DeliveryMethod = ({
  className,
  deliveryMethod,
  heading,
  id,
  //image,
  numberOfBanks,
  onSelect,
  personalData,
  showDeliveryMethod,
  unavailableText,
}) => (
  <div className={`delivery-method-box ${className} `}>
    <div
      className={
        showDeliveryMethod === deliveryMethod
          ? 'delivery-method-delivery delivery-method-deliverySelect'
          : 'delivery-method-delivery'
      }
      onClick={() => onSelect(showDeliveryMethod)}
    >
      <div className="delivery-method-image delivery-method-show-delivery-options">
        <RadioButton
          ariaLabel={id}
          category="addBankSelection"
          checked={showDeliveryMethod === deliveryMethod}
          disabled={false}
          id={id}
          labelText={
            <div className="delivery-method-text">
              <div className="delivery-method-description">{heading}</div>
              <div
                className={`delivery-method-sub-description e2e-${deliveryMethod}-estimate`}
              >
                <DeliveryMethodEstimation
                  className="delivery-method-show-delivery-options"
                  deliveryMethod={showDeliveryMethod}
                  numberOfBanks={numberOfBanks}
                  personalData={personalData}
                  unavailableText={unavailableText}
                />
              </div>
            </div>
          }
          tabIndex={'0'}
          value={deliveryMethod}
          onClick={() => onSelect(showDeliveryMethod)}
        />
      </div>
    </div>
    <div className="delivery-method-active-line" />
  </div>
);

export default DeliveryMethod;
